module.exports = __webpack_public_path__ + "img/img27.42d4a8ef.png";